import { useEffect, useMemo, useRef, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchSystemVehicleOptions } from '../../api/maintenance/systemVehicleApi';

const useDebounced = (value, delay = 350) => {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
};

export const useSystemVehicleOptions = (initialSearch = '') => {
  const [search, setSearch] = useState(initialSearch);
  const debounced = useDebounced(search, 350);

  const { data = [], isFetching, refetch } = useQuery({
    queryKey: ['systemVehicleOptions', debounced],
    queryFn: () => fetchSystemVehicleOptions({ q: debounced, limit: 20 }),
    staleTime: 1000 * 60 * 5,
    keepPreviousData: true,
  });

  // para preservar la opción seleccionada aunque cambie la búsqueda
  const mapById = useMemo(() => {
    const m = new Map();
    for (const it of data) m.set(it.sisvehid ?? it.sisvehID, it);
    return m;
  }, [data]);

  return {
    options: data ?? [],
    isFetching,
    search,
    setSearch,
    mapById,
    refetch,
  };
};
